module.exports = __webpack_public_path__ + "img/google-stadia-04.43852827.jpg";